export const creative = {
  id: 'creative',
  name: 'Designer & Creative',
  sectionOrder: ['summary', 'projects', 'experience', 'skills', 'education'],
  defaultLayout: 'sidebar-right',
  recommendedTemplates: ['creative-minimal'],
  components: {
    experience: 'experience-timeline',
    skills: 'skills-simple-list',
    header: 'header-classic'
  }
};
export default creative;
